import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function M3Icon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="M3">
      <path
        d="M3.8 4.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V7.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 4.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V7.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M8.8 18.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.6c.2 0 .3 0 .5.1.1.1.2.2.3.4l1.5 3.8 1.6-3.8c.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1h.6c.2 0 .3.1.4.2.1.1.2.2.2.4V18c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-3.9l-1 2.3c-.1.2-.2.3-.3.4-.1.1-.3.1-.5.1h-.3c-.2 0-.3 0-.5-.1-.1-.1-.2-.2-.3-.4l-1-2.3V18c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.3zm8.5-5.9c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2H21c.2 0 .3.1.4.2.1.1.2.2.2.4v.2c0 .4-.1.7-.4.9l-1.5 1.2h.1c.6 0 1 .2 1.4.5.4.4.5.8.5 1.5 0 .8-.2 1.4-.7 1.8-.5.4-1.2.6-2 .6-.5 0-1.1-.1-1.6-.2-.2 0-.3-.1-.4-.3-.1-.1-.1-.3-.1-.5v-.3c0-.1.1-.2.2-.3.1-.1.2-.1.4-.1.6.2 1.1.3 1.5.3.4 0 .7-.1.9-.3.2-.2.3-.4.3-.8 0-.3-.1-.6-.4-.7-.2-.1-.7-.2-1.4-.2-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4 0-.4.1-.7.4-.9l1.4-1.2h-2.3z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
